import { useState } from 'react';

import { useLinkPressedCallback, useButtonPressedCallback, useModalDisplayedEvent } from '@zenbusiness/application-commons-clickstream';
import BasicDialog from '@zenbusiness/zui/BasicDialog';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import SharedLottieAsset from '@zenbusiness/zui/SharedLottieAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import useActionTakenUpdate from '#client/hooks/useActionTakenUpdate';
import { useModal } from '#client/hooks/useModal';

function PersonalizedModal() {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const {
    data: modal,
    error,
    loading
  } = useModal();
  const {
    saveActionTaken,
    hasError: actionTakenError
  } = useActionTakenUpdate(modal?.instanceUuid);

  const lottieImage = modal?.image && String(modal?.image).endsWith('.json');

  useModalDisplayedEvent({
    open: !!modal,
    elementName: `${modal?.inAppKey}`
  });

  const handleLinkPressed = useLinkPressedCallback({
    elementName: 'personalize_modal_cta',
    elementText: modal?.ctaLabel,
    destination: modal?.ctaUrl
  });

  const handleButtonPressed = useButtonPressedCallback({
    elementName: 'modal_close',
    elementStyle: 'icon',
    elementAsset: modal?.image?.split('/').pop()
  });

  const handleClose = ({ status }) => {
    // Track All clicks
    const isCta = status === 'cta-clicked';
    if (isCta) {
      handleLinkPressed();
    } else {
      handleButtonPressed();
    }

    // Call mutation and Close the modal
    if (status === 'cta-clicked' || status === 'dismissed') {
      saveActionTaken(status);
      setIsModalOpen(false);
    }
  };

  if (error || loading || !modal?.title || actionTakenError) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return (
    <BasicDialog
      open={isModalOpen}
      onClose={() => handleClose({
        status: 'dismissed'
      })}
      primaryAction={{
        label: modal?.ctaLabel,
        onClick: () => {
          if (modal?.ctaUrl) {
            const target = modal?.ctaType === 'external' ? '_blank' : '_self';
            const link = document.createElement('a');
            link.href = modal.ctaUrl;
            link.target = target;
            link.click();
          }
          handleClose({ status: 'cta-clicked' });
        }
      }}
      subtitle={modal.subtitle}
      title={modal.title}
    >
      <Stack gap={3}>
        {lottieImage ? (
          <SharedLottieAsset
            src={modal.image}
            width="10rem"
            sx={{
              maxHeight: '10rem',
              margin: 'auto'
            }}
          />
        ) : (
          <SharedAsset
            alt="business-images"
            src={modal.image}
            width="10rem"
            sx={{
              maxHeight: '10rem',
              margin: 'auto'
            }}
          />
        )}

        {modal.caption && (
          <Text>
            {modal.caption}
          </Text>
        )}
      </Stack>
    </BasicDialog>
  );
}

export default PersonalizedModal;
